import React from 'react';

export default function NavigationMobileMenu(props) {
  return (
    <div
      className="block md:hidden"
      hidden={!props.isOpen}
    >
      {props.children}
    </div>
  );
}
